import React from 'react';
import theme from 'assets/theme';
import Topbar from '../Topbar';


interface IProps {
    children: React.ReactNode
}

let PublicLayout = ({ children }: IProps) => {
    return (
        <>
            <Topbar />
            <div style={{ padding: theme.spacing(2) }}>
                {children}
            </div>
        </>
    )
}

export default PublicLayout;